import * as types from "./types";
import { parseAuthors } from "./utils";

export default (state = {}, { type, isbn, citationInfo }) => {
  switch (type) {
    case types.GET_BOOK_CITATION_REQUEST:
      return {
        ...state,
        [isbn]: { isFetching: true },
      };
    case types.GET_BOOK_CITATION_SUCCESS:
      return {
        ...state,
        [isbn]: {
          info: {
            ...citationInfo,
            isbn,
            author: parseAuthors(citationInfo.contributors),
            date: citationInfo.copyrightDate || citationInfo.publicationDate,
          },
          isFetching: false,
        },
      };
    case types.GET_BOOK_CITATION_ERROR:
      return { ...state, [isbn]: { isFetching: false } };
    default:
      return state;
  }
};
